import { ref } from "vue";
const bus = ref(new Map());

export default function useEventsBus(){

    function emit(event, ...args) {
        bus.value.set(event, args);
    }

    return {
        emit,
        bus
    }
}

import mitt from 'mitt'

type Events = {
    "success-toast": string;
    "error-toast": string;
  };

export const emitter = mitt<Events>();
export const useEmitter = () => ({ emitter: emitter })